<script setup>

import { defineProps, defineExpose, ref, computed } from "vue";
import ModalFullscreen from "@/components/v2/modais/ModalFullscreen/ModalFullscreen.vue";
import BotaoTextoBase from "@/components/v2/base/BotaoTextoBase/BotaoTextoBase.vue";
import DadoConteudo from "./DadoConteudo.vue";
import UtilObject from "@/utils/UtilObject";
import JobAtualizarDataDeEntregaContratualService from "@/api/v2/services/JobAtualizarDataDeEntregaContratualService";

//==================================================================//
//========================= Props ===================================//
//==================================================================//

const props = defineProps({
    onClose: {
        type: Function,
        default: null
    }
});

//==================================================================//
//================== MODAL FULLSCREEN REF ===========================//
//==================================================================//

const modalFullscreenRef = ref();

//==================================================================//
//============================= Dado ===============================//
//==================================================================//

const dado = ref({});

//==================================================================//
//================ Data de Entrega Contratual Efetiva ================//
//==================================================================//

const disabled = ref(false);

const disabledAtualizar = computed(() => {

    if(disabled.value){
        return true;
    }

    if(!dado.value?.dataFinalEfetiva){
        return true;
    }

    return false;

});

//==================================================================//
//==================== Altera Dado de Compra =======================//
//==================================================================//

const alteraDado = (update = {})=>{

    dado.value = UtilObject.merge(dado.value, update)

};

//==================================================================//
//========================= Altera Item ============================//
//==================================================================//

const alteraItem = (update) => {

    let itens = dado?.value?.itens?.map((item)=>{

        if(item.id != update.id){
            return item;
        }

        return UtilObject.merge(item,update);

    });

    alteraDado({
        itens: itens
    });

};

//==================================================================//
//======================== Altera Aditivo ==========================//
//==================================================================//

const alteraAditivo = (update) => {

    let aditivos = dado?.value?.aditivos?.map((aditivo)=>{

        if(aditivo.id != update.id){
            return aditivo;
        }

        return Object.merge(aditivo, update);

    });

    alteraDado({
        aditivos: aditivos
    });

};

//===================================================================//
//========================== Prepara Dado ===========================//
//=================================================-=================//

const preparaDado = (dado = {})=>{

    let itens = dado?.itens?.map((item)=>{

        let subItens = item?.itens?.map((subItem)=>{

            return{
                id: subItem?.id || "",
                codigo: subItem?.codigo || "",
                sequencia: subItem?.sequencia || "",
                descricao: subItem?.descricao || "",
                quantidade: subItem?.quantidade || 0,
                valorUnitario: subItem?.valorUnitario || 0,
                valorTotal: subItem?.valorTotal || 0,
            };

        });

        return{
            id: item?.id || "",
            aberto: false,
            codigo: item?.codigo || "",
            status: item?.status || "",
            sequencia: item?.sequencia || "",
            descricao: item?.descricao || "",
            dataPrazoEntrega: item?.dataPrazoEntrega || "",
            dataPrazoEntregaFormatada: item?.dataPrazoEntregaFormatada || "",
            quantidade: item?.quantidade || 0,
            precoUnitario: item?.precoUnitario || 0,
            precoTotal: item?.precoTotal || 0,
            precoTotalLiquido: item?.precoTotalLiquido || 0,
            porcentagemIPI: item?.porcentagemIPI || 0,
            valorIPI: item?.valorIPI || 0,
            porcentagemBaseCalculoICMS: item?.porcentagemBaseCalculoICMS || 0,
            porcentagemICMS: item?.porcentagemICMS || 0,
            baseCalculoICMS: item?.baseCalculoICMS || 0,
            valorICMS: item?.valorICMS || 0,
            porcentagemBaseCalculoPIS: item?.porcentagemBaseCalculoPIS || 0,
            baseCalculoPIS: item?.baseCalculoPIS || 0,
            porcentagemPIS: item?.porcentagemPIS || 0,
            valorPIS: item?.valorPIS || 0,
            porcentagemBaseCalculoCOFINS: item?.porcentagemBaseCalculoCOFINS || 0,
            baseCalculoCOFINS: item?.baseCalculoCOFINS || 0,
            porcentagemCOFINS: item?.porcentagemCOFINS || 0,
            valorCOFINS: item?.valorCOFINS || 0,
            porcentagemBaseCalculoIRRF: item?.porcentagemBaseCalculoIRRF || 0,
            baseCalculoIRRF: item?.baseCalculoIRRF || 0,
            porcentagemIRRF: item?.porcentagemIRRF || 0,
            valorIRRF: item?.valorIRRF || 0,
            porcentagemBaseCalculoCSLL: item?.porcentagemBaseCalculoCSLL || 0,
            baseCalculoCSLL: item?.baseCalculoCSLL || 0,
            porcentagemCSLL: item?.porcentagemCSLL || 0,
            valorCSLL: item?.valorCSLL || 0,
            porcentagemBaseCalculoISS: item?.porcentagemBaseCalculoISS || 0,
            baseCalculoISS: item?.baseCalculoISS || 0,
            porcentagemISS: item?.porcentagemISS || 0,
            valorISS: item?.valorISS || 0,
            porcentagemBaseCalculoINSS: item?.porcentagemBaseCalculoINSS || 0,
            baseCalculoINSS: item?.baseCalculoINSS || 0,
            porcentagemINSS: item?.porcentagemINSS || 0,
            valorINSS: item?.valorINSS || 0,
            tipoDeEquipamento: item?.tipoDeEquipamento || {},
            tipoDeServico: item?.tipoDeServico || {},
            ncm: item?.ncm || {},
            itens: subItens || [],
            itensQuantidade: item?.itensQuantidade || 0,
        }

    });

    let aditivos = dado?.aditivos?.map((aditivo)=>{

        return{
            id: aditivo?.id || "",
            codigo: aditivo?.codigo || "",
            descricao: aditivo?.descricao || "",
            valorAdicional: aditivo?.valorAdicional || 0,
        }

    });

    dado = {
        id: dado?.id || "",
        status: dado?.status || "",
        codigo: dado?.codigo || "",
        jobTipo: dado?.jobTipo || "",
        tipoVenda: dado?.tipoVenda || "",

        valorDeCusto: dado?.valorDeCusto || 0,
        valorDeVenda: dado?.valorDeVenda || 0,
        valorDeVendaComImpostos: dado?.valorDeVendaComImpostos || 0,

        descricao: dado?.descricao || "",
        condicaoDePagamento: dado?.condicaoDePagamento || "",
        justificativaDeCancelamento: dado?.justificativaDeCancelamento || "",
        observacao: dado?.observacao || "",

        dataAbertura: dado?.dataAbertura || "",
        dataAberturaFormatada: dado?.dataAberturaFormatada || "",

        dataEntregaContratual: dado?.dataEntregaContratual || "",
        dataEntregaContratualFormatada: dado?.dataEntregaContratualFormatada || "",
        dataEncerramento: dado?.dataEncerramento || "",
        dataEncerramentoFormatada: dado?.dataEncerramentoFormatada || "",

        dataEnvioAprovacaoContratual: dado?.dataEnvioAprovacaoContratual || "",
        dataEnvioAprovacaoContratualFormatada: dado?.dataEnvioAprovacaoContratualFormatada || "",
        dataEnvioAprovacaoEfetiva: dado?.dataEnvioAprovacaoEfetiva || "",
        dataEnvioAprovacaoEfetivaFormatada: dado?.dataEnvioAprovacaoEfetivaFormatada || "",
        naoTemEnvioAprovacao: dado?.naoTemEnvioAprovacao || "",

        dataAprovacaoPrevista: dado?.dataAprovacaoPrevista || "",
        dataAprovacaoPrevistaFormatada: dado?.dataAprovacaoPrevistaFormatada || "",
        dataAprovacaoEfetiva: dado?.dataAprovacaoEfetiva || "",
        dataAprovacaoEfetivaFormatada: dado?.dataAprovacaoEfetivaFormatada || "",
        naoTemAprovacao: dado?.naoTemAprovacao || false,

        dataInspecaoPrevista: dado?.dataInspecaoPrevista || "",
        dataInspecaoPrevistaFormatada: dado?.dataInspecaoPrevistaFormatada || "",
        dataInspecaoEfetiva: dado?.dataInspecaoEfetiva || "",
        dataInspecaoEfetivaFormatada: dado?.dataInspecaoEfetivaFormatada || "",
        naoTemInspecao: dado?.naoTemInspecao || false,

        dataEntregaFiscalPrevista: dado?.dataEntregaFiscalPrevista || "",
        dataEntregaFiscalPrevistaFormatada: dado?.dataEntregaFiscalPrevistaFormatada || "",
        dataEntregaFiscalEfetiva: dado?.dataEntregaFiscalEfetiva || "",
        dataEntregaFiscalEfetivaFormatada: dado?.dataEntregaFiscalEfetivaFormatada || "",
        naoTemEntregaFiscal: dado?.naoTemEntregaFiscal || false,

        dataMontagemContratual: dado?.dataMontagemContratual || "",
        dataMontagemContratualFormatada: dado?.dataMontagemContratualFormatada || "",
        dataMontagemEfetiva: dado?.dataMontagemEfetiva || "",
        dataMontagemEfetivaFormatada: dado?.dataMontagemEfetivaFormatada || "",
        naoTemMontagem: dado?.naoTemMontagem || false,

        dataStartupPrevista: dado?.dataStartupPrevista || "",
        dataStartupPrevistaFormatada: dado?.dataStartupPrevistaFormatada || "",
        dataStartupEfetiva: dado?.dataStartupEfetiva || "",
        dataStartupEfetivaFormatada: dado?.dataStartupEfetivaFormatada || "",
        naoTemStartup: dado?.naoTemStartup || false,

        dataFinalContratual: dado?.dataFinalContratual || "",
        dataFinalContratualFormatada: dado?.dataFinalContratualFormatada || "",
        dataFinalEfetiva: dado?.dataFinalEfetiva || "",
        dataFinalEfetivaFormatada: dado?.dataFinalEfetivaFormatada || "",

        solicitacaoDeOrcamento: dado?.solicitacaoDeOrcamento || {},
        solicitacaoDeOrcamentoID: dado?.solicitacaoDeOrcamento?.id || "",
        solicitacaoDeOrcamentoCodigo: dado?.solicitacaoDeOrcamento?.codigo || "",
        solicitacaoDeOrcamentoValor: dado?.solicitacaoDeOrcamento?.valor || "",

        solicitacaoDeOrcamentoTipoDeEquipamentoID: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.id || "",
        solicitacaoDeOrcamentoTipoDeEquipamentoSigla: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.sigla || "",
        solicitacaoDeOrcamentoTipoDeEquipamentoDescricao: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.descricao || "",

        solicitacaoDeOrcamentoContatoComercialID: dado?.solicitacaoDeOrcamento?.contatoComercial?.id || "",
        solicitacaoDeOrcamentoContatoComercialTipo: dado?.solicitacaoDeOrcamento?.contatoComercial?.tipo || "",
        solicitacaoDeOrcamentoContatoComercialNome: dado?.solicitacaoDeOrcamento?.contatoComercial?.nome || "",

        solicitacaoDeOrcamentoContatoTecnicoID: dado?.solicitacaoDeOrcamento?.contatoTecnico?.id || "",
        solicitacaoDeOrcamentoContatoTecnicoTipo: dado?.solicitacaoDeOrcamento?.contatoTecnico?.tipo || "",
        solicitacaoDeOrcamentoContatoTecnicoNome: dado?.solicitacaoDeOrcamento?.contatoTecnico?.nome || "",

        cliente: dado?.cliente || {},
        clienteID: dado?.cliente?.id || "",
        clienteCodigo: dado?.cliente?.codigo || "",
        clienteNome: dado?.cliente?.nomeFantasia || "",
        clientePedidoDeCompra: dado?.clientePedidoDeCompra || "",
        clienteEmailXML: dado?.clienteEmailXML || "",

        comercialID: dado?.comercial?.id || "",
        comercialCodigo: dado?.comercial?.codigo || "",
        comercialNome: dado?.comercial?.nome || "",

        gestorID: dado?.gestorDeContratos?.id || "",
        gestorCodigo: dado?.gestorDeContratos?.codigo || "",
        gestorNome: dado?.gestorDeContratos?.nome || "",

        coordenadorID: dado?.coordenadorDeContratos?.id || "",
        coordenadorCodigo: dado?.coordenadorDeContratos?.codigo || "",
        coordenadorNome: dado?.coordenadorDeContratos?.nome || "",

        transporteID: dado?.transporte?.id || "",
        transporteCodigo: dado?.transporte?.codigo || "",
        transporteOrdem: dado?.transporte?.ordem || "",
        transporteSigla: dado?.transporte?.sigla || "",
        transporteDescricao: dado?.transporte?.descricao || "",
        transporteDescricaoCompleta: dado?.transporte?.descricaoCompleta || "",

        itens: itens || [],
        itensQuantidade: dado?.itensQuantidade || 0,

        aditivos: aditivos || [],
        aditivosQuantidade : dado?.aditivosQuantidade || 0,
    }

    alteraDado(dado);

};

//==================================================================//
//=========================== Ao Atualizar ===========================//
//==================================================================//

const aoAtualizar = async () => {

    try {

        disabled.value = true;

        const jobValores = {
            id: dado.value?.id || "",
            dateFinalEfetiva: dado.value?.dataFinalEfetiva || "",
        };

        await JobAtualizarDataDeEntregaContratualService.atualizarDataDeEntregaContratual(jobValores);

        await fecharModal();

    } finally {

        disabled.value = false;

    }

};

//==================================================================//
//======================== Prepara Modal ===========================//
//==================================================================//

const preparaModal = (dadoOriginal = {}) => {

    preparaDado(UtilObject.clone(dadoOriginal));

};

//==================================================================//
//================== ABRIR MODAL ===================================//
//==================================================================//

const abrirModal = async (dadoOriginal = {}) => {

    preparaModal(dadoOriginal);

    await modalFullscreenRef.value?.abrirModal();

};

//==================================================================//
//================== FECHAR MODAL ==================================//
//==================================================================//

const fecharModal = async () => {

    await modalFullscreenRef.value?.fecharModal();

};

//==================================================================//
//================== AO FECHAR MODAL ===============================//
//==================================================================//

const aoFecharModal = async () => {

    await props.onClose?.();

};

//==================================================================//
//================== EXPOSE ========================================//
//==================================================================//

defineExpose({ abrirModal, fecharModal });

</script>

<template>

    <ModalFullscreen
        ref="modalFullscreenRef"
        :dado="dado"
        @onClose="aoFecharModal"
    >

        <template #modal-navegacao-titulo>

            Atualizar Data de Entrega Contratual

        </template>

        <template #modal-navegacao-botoes>

            <BotaoTextoBase
                class="c-botao-salvar"
                color="#4caf50"
                :disabled="disabledAtualizar"
                :click="aoAtualizar"
            >
                Atualizar
            </BotaoTextoBase>

        </template>

        <template #modal-conteudo>

            <DadoConteudo
                :dado="dado"
                :disabled="disabled"
                @update:alteraItem="alteraItem"
                @update:alteraAditivo="alteraAditivo"
                @update:alteraDado="alteraDado"
            ></DadoConteudo>

        </template>

    </ModalFullscreen>

</template>

<style scoped>

.c-botao-salvar {
    width: 120px;
}

</style>
